import React from 'react';
import { Rec, SubHeader } from '../../component';
import wandu from '../../service/wandu';

export default class NewChannel extends React.Component {

    state = {
        section_data: [], 
        subheader: [{
                subTitle:'主编推荐',
                imgSrcs:'https://img.wandu.cn/novel/cover/2019-05-23/1A1C55A69F9B96819A587C5D5555565C.png'
            },{
                subTitle:'猜你喜欢',
                imgSrcs:'https://img.wandu.cn/novel/cover/2019-05-23/FF3BBB04B40F16B4521D4E2C62F3B872.png'
            },{
                subTitle:'完本推荐',
                imgSrcs:'https://img.wandu.cn/novel/cover/2019-05-23/8FCBB64B2DDDB47B11148D1CA044252F.png'
            },{
                subTitle:'新书推荐',
                imgSrcs:'https://img.wandu.cn/novel/cover/2019-05-23/89D13F03F3CD96BE6DCF3571266BCB50.png'
            }]
    }

    componentDidMount() {
        wandu.home({channel: this.props.channel_id}).then(res => {
            let section_data = [];
            res.data.forEach((item,i)=>{
                if(item.novels!==null){
                    section_data.push(item);
                }
            });

            console.log("NewChannel",section_data)

            this.setState({section_data:section_data.slice(0,4)});
        }).catch(e => {
            console.log(e); 
        })
    }

    render() {
        return (
        <div className='block' style={{border:'none',marginTop:'5px',padding:'0px'}}>
        {this.state.section_data.map((item, idx) => (
            <div key={idx}>
                <SubHeader title={item.title} imgSrc={item.imgSrc}/>
                <Rec.NewListRec
                    template='brief_10'
                    data={item.novels.map(book => ({
                        novel_id: book.novel_id, 
                        name: book.novel_name, 
                        pic: book.pic,
                        author: book.author_name,
                        cata: book.tag_name,
                        brief: book.summary,
                    }))}
                />
            </div>
        ))}
        </div>
        );  
    }
}



// WEBPACK FOOTER //
// ./src/layout/home/newchannel.js